export default [{
    path: "/app/set-new-goal",
    name: "set-new-goal",
    redirect: {
        name: 'dashboard'
    },
    component: () => import("../../../views/dashboard/customer/SetGoalComponent.vue"),
    meta: {
        allowedUsers: ['customer']
    }
}]
